<template>
  <el-image
    v-if="props.applicationName"
    class="logo app-icon"
    :src="`https://logos.saasmetrix.io/${encodeURIComponent(props.applicationName)}.png?origin=app`">
    <template #error>
      <span v-if="props.applicationType === 'SSO'">
        <div>
          <Cloud class="icon bg-gray-200 dark:bg-gray-600" />
        </div>
      </span>

      <LayoutGrid
        v-if="props.applicationType === SoftwareTypes.MANUALLY"
        class="icon bg-gray-200 dark:bg-gray-600"
        :absolute-stroke-width="true" />
      <Image v-else class="icon bg-gray-200 dark:bg-gray-600" />
    </template>
  </el-image>
  <Image v-else class="icon bg-gray-200 dark:bg-gray-600" />
</template>

<script setup lang="ts">
  import { SoftwareTypes } from '@/client'
  import { Image, Cloud, LayoutGrid } from 'lucide-vue-next'

  interface Props {
    applicationName: string
    applicationType?: SoftwareTypes | 'SSO' | null
    size?: number
  }

  const props = withDefaults(defineProps<Props>(), {
    size: 20,
    applicationType: undefined,
  })

  const pixelSize = computed(() => {
    return `${props.size}px`
  })
</script>

<style scoped lang="scss">
  .logo {
    height: v-bind(pixelSize);
    width: v-bind(pixelSize);
    transition: all 0.3s ease-in-out;
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius-small);
    height: v-bind(pixelSize);
    width: v-bind(pixelSize);
    transition: all 0.3s ease-in-out;
    padding: calc(v-bind(pixelSize) / 5);
  }
</style>

<style lang="scss">
  .app-icon path {
    opacity: 0.7;
  }
</style>
